import { HiSparkles, HiArrowTrendingUp } from "react-icons/hi2";
import Header from "../../components/common/header";
import { useNavigate } from "react-router-dom";
import { notify } from "../../utils/toast";

const benefitCards = [
  {
    icon: <HiSparkles className="w-6 h-6 text-[#1562fc]" />,
    title: "가입 완료 시 자동 지급",
    description: "회원가입을 완료하면 스탬프가 자동으로 적립돼요.",
  },
  {
    icon: <HiArrowTrendingUp className="w-6 h-6 text-[#1562fc]" />,
    title: "스탬프 2개 적립",
    description:
      "적립된 스탬프로 10개 채우기에 더 빠르게 다가가요. 10개 모으면 1,000원 할인 쿠폰으로 교환할 수 있습니다.",
  },
];

const WelcomeStampPage = () => {
  const navigate = useNavigate();

  const handleIssueClick = () => {
    notify("가입하시면 자동으로 적립돼요.");
    setTimeout(() => navigate("/login"), 150);
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header title="웰컴 스탬프" showBackButton />

      <div className="flex-1 overflow-y-auto pb-24">
        <section className="px-5 pt-8">
          <div className="rounded-3xl bg-gradient-to-br from-[#1562fc] to-[#58a6ff] text-white p-6 shadow-xl">
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-white/80">
              Welcome Stamp
            </p>
            <h1 className="text-3xl font-bold mt-2 leading-tight">
              웰컴 스탬프
              <br />
              2개
            </h1>
            <p className="text-sm text-white/80 mt-3">
              가입하시면 웰컴 스탬프가 자동으로 적립돼요. 스탬프 10개를 모으면
              1,000원 할인 쿠폰으로 교환할 수 있습니다.
            </p>
          </div>
        </section>

        <section className="px-5 mt-8 space-y-4">
          {benefitCards.map((benefit) => (
            <div
              key={benefit.title}
              className="flex items-start gap-4 p-4 rounded-2xl bg-[#f5f8ff] border border-[#e2e9ff]"
            >
              <div className="mt-1">{benefit.icon}</div>
              <div>
                <h3 className="text-base font-semibold text-gray-900">
                  {benefit.title}
                </h3>
                <p className="text-sm text-gray-600 mt-1">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </section>
      </div>

      <div className="fixed bottom-0 left-0 right-0 px-4 pb-6 pt-2 bg-white border-t border-gray-100">
        <button
          type="button"
          onClick={handleIssueClick}
          className="w-full bg-[#1562fc] text-white font-semibold py-4 rounded-2xl text-lg shadow-lg hover:bg-[#0f4dcf] transition-colors"
        >
          웰컴 스탬프 받기
        </button>
        <p className="text-center text-xs text-gray-500 mt-2">
          가입 시 스탬프가 적립되며, 10개 모으면 1,000원 할인 쿠폰으로 교환할 수
          있습니다.
        </p>
      </div>
    </div>
  );
};

export default WelcomeStampPage;
